module.exports = __webpack_public_path__ + "img/donation.1465545e.png";